
import Vue from "vue";

export default Vue.extend({
  name: "TabButton",
  props: {
    label: {
      type: String,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    iconSrc: {
      type: String,
      default: "",
    },
    iconAlt: {
      type: String,
      default: "",
    },
  },
});
